<form>
  <ng-container *transloco="let t; read: 'ime.manufacturing.manufactured-item-groups'">
    <ul ngbNav #nav="ngbNav" class="nav-tabs" (navChange)="selectTab($event)" [(activeId)]="selectedTab">
      <li ngbNavItem="general" [destroyOnHide]="false">
        <a ngbNavLink>
          <span class="badge bg-danger" *ngIf="(wasValidated$ | async) && !manufacturedItemGroup?.isValid()">!</span>
          {{t('General info')}}
          <help-button *transloco="let h" [key]="h('help.ime.manufacturing.item-groups')"></help-button>
        </a>
        <ng-template ngbNavContent>
          <ng-container *ngIf="manufacturedItemGroup">
            <div class="row pb-2 g-2">
              <div class="col-6">
                <div class="card">
                  <div class="card-body">
                    <div class="form-group row">
                      <label for="code" class="col-sm-4 col-form-label">{{t('Code')}}</label>
                      <div class="col-sm-8">
                        <input type="text" class="form-control bg-white-100" id="code" name="code" [(ngModel)]="manufacturedItemGroup.Code" [readonly]="readonly">
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="name" class="col-sm-4 col-form-label">{{t('Name')}}</label>
                      <div class="col-sm-8">
                        <input type="text" class="form-control bg-white-100" id="name" name="name" [(ngModel)]="manufacturedItemGroup.Name" [readonly]="readonly">
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="itemType" class="col-sm-4 col-form-label">{{t('Type')}}</label>
                      <div class="col-sm-8">
                        <mes-web-classificator-value-select [entityId]="manufacturedItemGroup.TypeClv"
                                                            (entityIdChange)="manufacturedItemGroup.TypeClv = $event"
                                                            name="itemType" id="itemType"
                                                            [items$]="classificatorValuesQuery.itemGroupTypes$"
                                                            [allowAdd]="false"
                                                            [readonly]="readonly"></mes-web-classificator-value-select>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="InventoryUnit" class="col-sm-4 col-form-label">{{t('Inventory Unit')}}</label>
                      <div class="col-sm-8">
                        <mes-web-unit-select [entityId]="manufacturedItemGroup.InventoryUnitId" [readonly]="readonly"
                                             (entityIdChange)="manufacturedItemGroup.InventoryUnitId = $event"
                                             name="InventoryUnit" id="InventoryUnit"
                                             [items$]="unitService.getAll$"></mes-web-unit-select>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="ProductionUnit" class="col-sm-4 col-form-label">{{t('Production Unit')}}</label>
                      <div class="col-sm-8">
                        <mes-web-unit-select [entityId]="manufacturedItemGroup.ProductionUnitId" [readonly]="readonly"
                                             (entityIdChange)="manufacturedItemGroup.ProductionUnitId = $event"
                                             name="ProductionUnit" id="ProductionUnit"
                                             [items$]="unitService.getAll$"></mes-web-unit-select>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="RouteUnit" class="col-sm-4 col-form-label">{{t('Route Unit')}}</label>
                      <div class="col-sm-8">
                        <mes-web-unit-select [entityId]="manufacturedItemGroup.RouteUnitId" [readonly]="readonly"
                                             (entityIdChange)="manufacturedItemGroup.RouteUnitId = $event"
                                             name="RouteUnitId" id="RouteUnit"
                                             [items$]="unitService.getAll$"></mes-web-unit-select>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="status" class="col-sm-4 col-form-label">{{t('Status')}}</label>
                      <div class="col-sm-8">
                        <div class="input-group">
                          <div class="flex-grow-1 px-0">
                            <mes-web-classificator-value-select [entityId]="manufacturedItemGroup.StatusClv"
                                                                (entityIdChange)="manufacturedItemGroup.StatusClv = $event"
                                                                name="status" id="status"
                                                                [items]="classificatorValuesQuery.itemGroupStatuses$ | async"
                                                                [allowAdd]="false"></mes-web-classificator-value-select>
                          </div>
                          <div class="btn-group ms-1" ngbDropdown container="body" *ngIf="(manufacturedItemGroup.ParentId || manufacturedItemGroup.DraftId)">
                            <button class="dropdown-toggle btn btn-outline-primary btn-sm" ngbDropdownToggle role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            </button>
                            <div class="dropdown-menu dropdown-menu-sm dropdown-menu-start" ngbDropdownMenu>
                                  <span class="p-2">
                                    {{manufacturedItemGroup.StatusClv === Classificators.ItemGroupStatus.Draft ? t('Final') : t('Draft')}}
                                  </span>
                              <button class="dropdown-item" ngbDropdownItem (click)="openItemGroup()">
                                <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#computer-desktop"></svg>
                                {{t('Open')}}

                              </button>
                              <a class="dropdown-item" ngbDropdownItem href [routerLink]="['/manufacturing/item-template/edit', manufacturedItemGroup.ParentId ?? manufacturedItemGroup.DraftId]">
                                <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#arrow-top-right-on-square"></svg>
                                {{t('Navigate')}}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="autoReplenishFlag" class="col-sm-4 col-form-label">{{t('Auto Replenish Flag')}}</label>
                      <div class="col-sm-8">
                        <ng-select class="select-sm form-control" [items]="classificatorValuesQuery.autoReplenishFlags$ | async" [readonly]="readonly"
                                   labelForId="autoReplenishFlag" name="autoReplenishFlag" [(ngModel)]="manufacturedItemGroup.AutoReplenishFlagClv"
                                   bindLabel="DisplayName" [virtualScroll]="true"
                                   bindValue="Id" id="autoReplenishFlag">
                        </ng-select>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="comment" class="col-sm-4 col-form-label">{{t('Comment')}}</label>
                      <div class="col-sm-8">
                        <textarea class="form-control bg-white-100" id="comment" name="comment" [(ngModel)]="manufacturedItemGroup.Comment" [readonly]="readonly"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <ng-container [ngTemplateOutlet]="connectionList" [ngTemplateOutletContext]="{title: t('From'), connections: manufacturedItemGroup.Children, type: 'From'}">
                </ng-container>
                <ng-container [ngTemplateOutlet]="connectionList" [ngTemplateOutletContext]="{title: t('To'), connections: manufacturedItemGroup.Parents, type: 'To'}">
                </ng-container>
                <ng-template #connectionList let-title="title" let-connections="connections" let-type="type">
                  <div class="card mb-2">
                    <div class="card-body">
                      <div class="d-flex">
                        <h5 class="d-inline my-auto">{{title}}</h5>
                        <button class="btn btn-sm btn-outline-primary ms-auto" *ngIf="!readonly" (click)="addConnection(type)">
                          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
                          {{t('Add')}}
                        </button>
                      </div>
                      <p-table *ngIf="connections?.length"
                               styleClass="p-datatable-xs p-datatable-borderless white-rows p-inner-table-auto mt-1"
                               [value]="connections"
                               [rowHover]="true"
                               [autoLayout]="false"
                               [rowTrackBy]="trackByFunction"
                               [paginator]="connections.length > 10"
                               [showCurrentPageReport]="true"
                               [rowsPerPageOptions]="[10,25,50,100,200]"
                               [rows]="type === 'To' ? toConnectionRowsPerPage : fromConnectionRowsPerPage" (rowsChange)="type === 'To' ? toConnectionRowsPerPage : fromConnectionRowsPerPage = $event"
                               [first]="type === 'To' ? toConnectionFirstRow : fromConnectionFirstRow" (firstChange)="type === 'To' ? toConnectionFirstRow : fromConnectionFirstRow = $event"
                               [customSort]="true"
                               (sortFunction)="customSort($event)"
                               currentPageReportTemplate="{first} to {last} of {totalRecords}"
                               dataKey="Id">
                        <ng-template pTemplate="header">
                          <tr>
                            <th class="wx-48" pSortableColumn="Sequence" title="{{t('Sequence')}}">
                              #
                              <p-sortIcon field="Sequence"></p-sortIcon>
                            </th>
                            <th class="min-wx-192" pSortableColumn="{{type === 'To' ? 'ParentId' : 'ChildId'}}">
                              {{t('Item Group')}}
                              <p-sortIcon field="{{type === 'To' ? 'ParentId' : 'ChildId'}}"></p-sortIcon>
                            </th>
                            <th style="width: 170px">
                              {{t('From/To')}}
                            </th>
                            <th class="wx-64" pSortableColumn="IsDefault">
                              {{t('Main')}}
                              <p-sortIcon field="IsDefault"></p-sortIcon>
                            </th>
                            <th style="width: 76px"></th>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-row>
                          <tr class="p-selectable-row">
                            <td pEditableColumn class="parent">
                              <p-cellEditor>
                                <ng-template pTemplate="output">
                                  <ng-container *ngIf="!row.Sequence && !readonly" [ngTemplateOutlet]="editIcon" [ngTemplateOutletContext]="{columnName: 'ime.manufacturing.manufactured-item-groups.#'}"></ng-container>
                                  <div class="d-flex w-100">
                                    <span class="ms-auto">{{row.Sequence}}</span>
                                  </div>
                                </ng-template>
                                <ng-template pTemplate="input">
                                  <input mesStopArrowKeyPropagation type="number" class="form-control" id="Sequence-{{row.Id}}" name="Sequence-{{row.Id}}" [(ngModel)]="row.Sequence" [readonly]="readonly">
                                </ng-template>
                              </p-cellEditor>
                            </td>
                            <td pEditableColumn mesStopClickPropagation class="text-wrap text-break parent">
                              <ng-container *ngIf="type === 'To'; else fromConnections">
                                <p-cellEditor *ngIf="!row.$isNew; else selectItemGroupTmpl">
                                  <ng-template pTemplate="output">
                                    <ng-container *ngIf="!row.ParentId && !readonly; else fromItemGroupTmpl" [ngTemplateOutlet]="editIcon" [ngTemplateOutletContext]="{columnName: 'ime.manufacturing.manufactured-item-groups.Item Group'}"></ng-container>
                                    <ng-template #fromItemGroupTmpl>
                                      <span [ngClass]="{'fw-bold': row.isActiveDefault()}">{{(manufacturedItemGroupService.getAll$ | async | find: ['Id'] : row.ParentId) | displayName}}</span>
                                    </ng-template>
                                  </ng-template>
                                  <ng-template pTemplate="input">
                                    <ng-template [ngTemplateOutlet]="selectItemGroupTmpl"></ng-template>
                                  </ng-template>
                                </p-cellEditor>
                              </ng-container>
                              <ng-template #fromConnections>
                                <p-cellEditor *ngIf="!row.$isNew; else selectItemGroupTmpl">
                                  <ng-template pTemplate="output">
                                    <ng-container *ngIf="!row.ChildId && !readonly; else toItemGroupTmpl" [ngTemplateOutlet]="editIcon" [ngTemplateOutletContext]="{columnName: 'ime.manufacturing.manufactured-item-groups.Item Group'}"></ng-container>
                                    <ng-template #toItemGroupTmpl>
                                      <span [ngClass]="{'fw-bold': row.isActiveDefault()}">{{(manufacturedItemGroupService.getAll$ | async | find: ['Id'] : row.ChildId) | displayName}}</span>
                                    </ng-template>
                                  </ng-template>
                                  <ng-template pTemplate="input">
                                    <ng-template [ngTemplateOutlet]="selectItemGroupTmpl"></ng-template>
                                  </ng-template>
                                </p-cellEditor>
                              </ng-template>
                              <ng-template #selectItemGroupTmpl>
                                <mes-web-manufacturing-item-group-select [items$]="manufacturedItemGroupService.getAll$"
                                                                         [readonly]="readonly" [initOpened]="true"
                                                                         name="itemGroup-{{row.Id}}" id="itemGroup-{{row.Id}}"
                                                                         [entityId]="type === 'To' ? row.ParentId : row.ChildId"
                                                                         (entityIdChange)="type === 'To' ? row.ParentId = $event : row.ChildId = $event; row.$isNew = false"></mes-web-manufacturing-item-group-select>
                              </ng-template>
                            </td>
                            <td pEditableColumn mesStopClickPropagation class="parent">
                              <p-cellEditor>
                                <ng-template pTemplate="output">
                                  <ng-container *ngIf="!row.FromDate && !row.ToDate && !readonly; else fromToTmpl" [ngTemplateOutlet]="editIcon" [ngTemplateOutletContext]="{columnName: 'ime.manufacturing.manufacturing-item.From/To'}"></ng-container>
                                  <ng-template #fromToTmpl>
                                    <div>
                                      {{row.FromDate | date: 'dd.MM.yyyy'}} - {{row.ToDate | date: 'dd.MM.yyyy'}}
                                    </div>
                                  </ng-template>
                                </ng-template>
                                <ng-template pTemplate="input">
                                  <mes-date-range-picker [fromDate]="row.FromDate" [toDate]="row.ToDate" [format]="'dd.MM.yyyy'" [hasButton]="false" [small]="false" [disabled]="readonly" [initOpened]="true"
                                                         (dateSelect)="setDateRange($event, row)"></mes-date-range-picker>
                                </ng-template>
                              </p-cellEditor>
                            </td>
                            <td>
                              <div class="d-flex">
                                <input type="checkbox" class="form-check-input position-static mx-auto my-auto" [(ngModel)]="row.IsDefault" [disabled]="readonly" id="IsMain-{{row.Id}}" name="IsMain-{{row.Id}}">
                              </div>
                            </td>
                            <td style="white-space: nowrap">
                              <button class="btn btn-sm btn-outline-primary me-1" (click)="openItemGroup(type === 'To' ? row.ParentId : row.ChildId)">
                                <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#arrow-top-right-on-square"></svg>
                              </button>
                              <button class="btn btn-sm btn-outline-danger" *ngIf="!readonly" (click)="removeConnection(row, type)">
                                <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#trash"></svg>
                              </button>
                            </td>
                          </tr>
                        </ng-template>
                        <ng-template #editIcon let-columnName="columnName">
                          <span class="show-on-parent-hover text-gray-400 text-nowrap">
                            {{columnName | transloco}}
                            <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
                          </span>
                        </ng-template>
                      </p-table>
                    </div>
                  </div>
                </ng-template>
                <div class="w-100"></div>
                <app-datasets-edit-card [container]="manufacturedItemGroup" [readonly]="readonly" [cssClass]="'mb-2'" (changed)="setChanged()"/>
                <mes-web-unit-conversions-edit [container]="manufacturedItemGroup" [readonly]="readonly" (changed)="setChanged()"/>
                <div class="card mt-2" *ngIf="settings?.Ime.ShowHierarchy">
                  <div class="card-body">
                    <div class="d-flex">
                      <h5 class="d-inline my-auto">{{t('Hierarchy')}}</h5>
                      <button type="button" class="btn btn-outline-primary btn-sm ms-auto" (click)="showHierarchy()" *ngIf="!readonly">
                        <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#check'"></svg>
                        {{t('Hierarchy')}}
                      </button>
                    </div>
                    <ng-container *ngIf="hierarchyNodes && manufacturedItemGroup.HierarchyNodes.length">
                      <span *ngFor="let nodeId of manufacturedItemGroup.HierarchyNodes" class="badge badge bg-primary me-1">
                        {{(hierarchyNodes | find : 'Id' : nodeId)?.Name}}
                      </span>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <div class="row pb-2">
              <div class="col">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex pb-1">
                      <h5 class="d-inline-block my-auto">{{t('Specs')}}</h5>
                      <help-button *transloco="let h" [key]="h('help.ime.common.specs')"></help-button>
                      <div class="ms-auto">
                        <button type="button" class="btn btn-sm btn-outline-primary me-1" [ngClass]="{'active': showPropertyLocalizations}" *ngIf="settings?.Property.Localization"
                                (click)="showPropertyLocalizations = !showPropertyLocalizations">
                          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#flag"></svg>
                          {{t('Localization')}}
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-primary" (click)="specLinesEditComponent?.addNewSpecLine()" *ngIf="!readonly">
                          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
                          {{t('Add')}}
                        </button>
                      </div>
                    </div>
                    <ime-spec-lines-edit [context]="manufacturedItemGroup"
                                         [showLocalization]="showPropertyLocalizations"
                                         [showLocalizationButton]="settings?.Property.Localization"
                                         [wasValidated$]="wasValidated$"
                                         [readonly]="readonly"
                                         (changed)="setChanged()">
                    </ime-spec-lines-edit>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-template>
      </li>
      <li ngbNavItem="ime" [destroyOnHide]="false" *ngIf="manufacturedItemGroup?.isManufactured()">
        <a ngbNavLink>
          {{t('IME')}}
        </a>
        <ng-template ngbNavContent>
          <mes-web-integrated-master-editor *ngIf="manufacturedItemGroup?.SaveRouting"
                                            [masterOperations]="manufacturedItemGroup.MasterOperations" [processSelectors]="manufacturedItemGroup.ProcessSelectors"
                                            [scrollIntoViewId]="scrollIntoViewId"
                                            [allowItemGroupsAsInputs]="settings.Ime.Features.AllowItemGroupAsInput"
                                            [allowItemGroupsAsOutputs]="settings.Ime.Features.AllowItemGroupAsOutput"
                                            [allowResourceTemplate]="settings.Ime.Features.AllowResourceTemplate"
                                            [readonly]="readonly"
                                            (processSelectorChanged)="manufacturedItemGroup.ProcessSelectors = $event; setChanged()"
                                            (masterOperationChanged)="manufacturedItemGroup.MasterOperations = $event; setChanged()">
          </mes-web-integrated-master-editor>
        </ng-template>
      </li>
      <li class="ms-auto my-auto pe-2 text-gray-500">
        <span>{{modifiedBy}}</span>
        <app-favourites-toggle [model]="manufacturedItemGroup" [route]="'manufacturing/item-template/edit/'"></app-favourites-toggle>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
  </ng-container>
</form>
